import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'; // Need this to push to history and redirect user properly
import { CardElement, injectStripe, StripeProvider, Stripe } from 'react-stripe-elements';

// Components
import Modal from '../../modal/Modal';
import Button from '../../modal/Button';
import GeneralLoader from '../../GeneralLoader';

// State
import { sendPaymentStripe, resetPaymentErrors } from '../../../store/actions/checkout';

// CSS
import '../../../css/payment.css';
import '../../../css/stripe.css';

// Util
import { setTransaction as setTransactionGA } from '../../../utils/google-analytics';

class PaymentSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showPaymentModal: false,
            // uncomment the line below when going to test mode
            // stripe: null
        };

        this.submit = this.submit.bind(this);
        this.validateStripe = this.validateStripe.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        // console.log('UNSAFE_componentWillReceiveProps:', nextProps.loading)
        // If errors exist and payment isn't processing anymore
        if (this.props.loading && !nextProps.loading) {
            this.setState({ showPaymentModal: false });
        }
    }

    handleKeyPress(event) {
        if (event.key === 'Enter') {
            this.handleSubmit(event);
        }
    }

    submit(ev) {
        ev.preventDefault();

        this.props.resetPaymentErrors();

        // Show modal
        this.setState(
            {
                stripeErrors: false,
                loading: true,
                showPaymentModal: true,
            },
            () => {
                // Handle Stripe
                this.validateStripe(ev);
            }
        );
    }

    async validateStripe(ev) {
        try {
            //uncomment the line below to go into test mode as well as the stripe state at the top of this file
            // this.setState({
            // 	stripe: window.Stripe("pk_test_PDzQFir3QmKJokgaZszdfOU9")
            // });
            const tokenResponse = await this.props.stripe.createToken({
                name: this.props.userEmail,
                // name: this.props.store.billingAddress.addresses[0].fname + " " + this.props.store.billingAddress.addresses[0].lname,
                // name: "lam"
                // email: this.props.userEmail
                // name: "lami",,

                // description: this.props.itemName
            });

            if (tokenResponse.error) {
                this.setState({
                    loading: false,
                    stripeErrors: tokenResponse.error.message,
                });
                return;
            }

            // Send payment to API
            this.props.sendPaymentStripe(tokenResponse.token.id).then((resp) => {
                // All good, gonna clean up and leave this component/page
                if (resp !== undefined) {
                    // Send transaction to GA
                    setTransactionGA(resp.transaction);
                    // console.log("this is the resp variable", resp);
                    // If successfully called, push the user to the receipt page
                    this.props.history.push(
                        '/order-summary?order=' +
                            resp.order +
                            '&access=' +
                            resp.access_token
                    );
                }
                // Some junk happened, so lets make sure we're not loading anymore
                else {
                    this.setState({ loading: false });
                }
            });
        } catch (err) {
            console.log(err);
        }
    }

    render() {
        const { errors } = this.props;
        const { loading, stripeErrors } = this.state;

        return (
            <div>
                <div className="delivery-heading">
                    <h2>Enter card info:</h2>
                </div>

                <div className="shipping-form tight-form-fields">
                    <div className="pb1">
                        <CardElement hidePostalCode={true} />
                    </div>

                    <div className="btn_container">
                        {errors.general && <div className="error">{errors.general}</div>}
                        <button
                            className={'btn submit-btn' + (loading ? ' loading' : '')}
                            onClick={this.submit}
                            disabled={loading}
                        >
                            <span>Submit Order</span>
                        </button>
                    </div>

                    {/* PAYMENT MODAL */}
                    {this.state.showPaymentModal && (
                        <Modal
                            title={'Payment Processing'}
                            buttons={[
                                {
                                    type: Button,
                                    text: 'Close',
                                    action: () =>
                                        this.setState({ showPaymentModal: false }),
                                    disabled: this.props.loading,
                                },
                            ]}
                        >
                            {loading && <GeneralLoader />}
                            {!loading &&
                                (stripeErrors ? (
                                    <div className="error">{stripeErrors}</div>
                                ) : (
                                    <div>Done</div>
                                ))}
                        </Modal>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        store: state,
        // userEmail: state.user.customer.user.email,
        userEmail: state.user.customer ? state.user.customer.user.email : 'guest',
        itemName: state.cart.items.title,
        loading: state.checkout.paymentInProcess,
        errors: state.checkout.paymentErrors,
    };
};

export default withRouter(
    injectStripe(
        connect(
            mapStateToProps,
            { sendPaymentStripe, resetPaymentErrors }
        )(PaymentSection)
    )
);



// WEBPACK FOOTER //
// ./src/components/checkout/payment/PaymentSection.js